import React, { useState, useEffect } from "react";
import "./ReviewsPage.css";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import { getProjectMasterList } from "./Redux/ProjectMasterSlice";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useMsal } from "@azure/msal-react";
import { updateLoginUserName } from "../function-components/Redux/ProjectMasterSlice";
import { FormControl, Autocomplete } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import {ReviewModel} from "./ReviewCommentsModel";

const ReviewsPage = () => {
  const baseURL = "https://atcilkm.listracker.accenture.com/listracker-apis";
  const projectData = useSelector(
    (state) => state.projectMaster.projectMasterList
  );
  const [openModal, setOpenModal] = useState(false);
  const [opencloseReviewModel, setOpenCloseReviewModel] = useState(false)
  const { instance } = useMsal();
  const activeAccount = instance.getActiveAccount();
  const handleModalClose = () => {
    setOpenModal(false);
  };
  const [comments, setComments] = useState([]);
  const [newComment, setNewComment] = useState("");
  const [editableRows, setEditableRows] = useState({});
  const username = useSelector((state) => state.projectMaster.username);

  const [tabvalue, setTabValue] = React.useState("1");
  const dispatch = useDispatch();
  const uniqueProjectNames = [
    ...new Set(projectData.map((project) => project.name)),
  ];
  const columns = [
    {
      field: "id",
      headerName: "#SL",
      type: "number",
      width: 60,
      align: "left",
      editable: false,
    },
    {
      field: "reviewcomments",
      headerName: "Review Comments",
      type: "text",
      width: 320,
      align: "left",
      headerAlign: "left",
      editable: true,
    },
    {
      field: "reviewdate",
      headerName: "Review Date",
      width: 120,
      editable: true,
    },
    {
      field: "createdby",
      headerName: "Created By",
      width: 120,
      editable: true,
    },
    { field: "reviewer", headerName: "Reviewer", width: 100, editable: true },
    { field: "fixedby", headerName: "Fixed By", width: 120, editable: true },
    {
      field: "closedate",
      headerName: "Close Date",
      width: 100,
      editable: true,
    },
    { field: "status", headerName: "Status", width: 100, editable: true },
    {
      field: "action",
      headerName: "Action",
      width: 100,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="primary"
          onClick={() => handleEditToggle(params.row.id)}
        >
          {editableRows[params.row.id] ? "Save" : "Edit"}
        </Button>
      ),
    },
  ];
  const handleOpenModal = () => {
    setOpenModal(true);
  };
  const handleOpenreviewcloseModal = () => {
    setOpenCloseReviewModel(true);
  };
  useEffect(() => {
    if (activeAccount) {
      dispatch(updateLoginUserName(activeAccount.idTokenClaims.enterpriseID));
    } else {
      dispatch(updateLoginUserName(null));
    }
  }, [activeAccount]);
  useEffect(() => {
    dispatch(getProjectMasterList("all"));
  }, []);
  const handleCommentChange = (event) => {
    setNewComment(event.target.value);
  };

  const handleCommentSubmit = () => {
    if (newComment.trim() !== "") {
      const lines = newComment.split("\n").filter((line) => line.trim() !== "");
      const newComments = lines.map((line, index) => ({
        id: comments.length + index + 1,
        reviewdate: new Date().toLocaleDateString(),
        reviewcomments: line,
        createdby: username,
        reviewer: "",
        fixedby: "",
        closedate: "",
        status: "",
      }));
      setComments((prevComments) => [...prevComments, ...newComments]);
      setNewComment("");
    }
  };
  const handleEditChange = (id, field, value) => {
    setComments((prevComments) =>
      prevComments.map((comment) =>
        comment.id === id ? { ...comment, [field]: value } : comment
      )
    );
  };
  const handleEditToggle = (id) => {
    setEditableRows((prevEditableRows) => ({
      ...prevEditableRows,
      [id]: !prevEditableRows[id],
    }));
  };
  const breadcrumbs = [
    <Link underline="hover" key="1" color="inherit" href="/ProjectArtifacts">
      Project Artifacts
    </Link>,
    <Typography key="2" color="text.primary">
      Review
    </Typography>,
  ];
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  return (
    <>
      <div className="review-main-container">
        <Stack spacing={2}>
          <Breadcrumbs separator="›" aria-label="breadcrumb">
            {breadcrumbs}
          </Breadcrumbs>
        </Stack>
        <div className="project-selection">
          <div className="project-sub-selection">
            <FormControl sx={{ m: 1, minWidth: 120 }}>
              <Autocomplete
                className="selectreviewProjectName"
                options={uniqueProjectNames}
                renderInput={(params) => (
                  <Stack className="selectionField">
                    <img
                      alt="list-icon"
                      src="/images/ProjectArtifacts/list-icon.png"
                    />
                    <TextField
                      {...params}
                      placeholder="Select Project"
                      variant="standard"
                    />
                  </Stack>
                )}
              />
            </FormControl>
          </div>
        </div>
        <Stack className="selectionTab">
          <TabContext value={tabvalue}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                onChange={handleTabChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Design" value="1" />
                <Tab label="Development" value="2" />
              </TabList>
            </Box>
            <Box className="review-table">
              <TabPanel value="1">
                <div className="main-review-table">
                  <DataGrid
                    rows={comments}
                    columns={columns}
                    pageSize={5}
                    checkboxSelection={false}
                    disableSelectionOnClick
                    disableColumnFilter
                    disableColumnMenu
                    editRowsModel={handleEditToggle}
                    onEditRowModelChange={handleEditChange}  
                  />
                </div>
                <div  className = 'add-btn' style={{ textAlign: 'center', marginTop: '8px', backgroundColor:'whitesmoke'}}>
                    <Button  onClick={handleOpenModal}>
                      <AddIcon sx={{width:'15px', marginRight:'5px'}}/> Add review comments
                    </Button>
                    </div>
                    <div>
                      <Button className="close-review-btn" onClick={handleOpenreviewcloseModal}>
                        Close review
                      </Button>
                    </div>
              </TabPanel>
              <TabPanel value="2">Development Team Table</TabPanel>
            </Box>
          </TabContext>
        </Stack>
      </div>
      <ReviewModel
        open={openModal}
        handleClose={handleModalClose}
        title="Add Review Comments"
        handleSubmit = {handleCommentSubmit}    
      >
        <div>
          <TextField
            id="comment-input"
            label="Type here..."
            variant="outlined"
            value={newComment}
            onChange={handleCommentChange}
            multiline
            sx={{minHeight:"200px", minWidth:"500px", marginTop:"10px"}}
          />
        </div>
      </ReviewModel>
    </>
  );
};

export default ReviewsPage;
